function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_53849",
  "data-name": "Path 53849",
  d: "M691.8,574.984l-5.078,5.079-.3.253-.3-.253-5.078-5.079.609-.609,4.774,4.8,4.773-4.8Z",
  fill: "#1c1d21"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_53850",
  "data-name": "Path 53850",
  d: "M691.8,574.984l-5.078,5.079-.3.253-.3-.253-5.078-5.079.609-.609,4.774,4.8,4.773-4.8Z",
  fill: "none",
  stroke: "#1c1d21",
  strokeWidth: 1
});

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.18,
    height: 7.299,
    viewBox: "0 0 12.18 7.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(-680.331 -573.667)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56549",
    "data-name": "Group 56549",
    style: {
      isolation: "isolate"
    }
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    id: "Group_56550",
    "data-name": "Group 56550",
    style: {
      isolation: "isolate"
    }
  }, _ref3)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.4c638a70.svg";
export { ForwardRef as ReactComponent };